
import Vue, {VueConstructor} from 'vue'
import QueryMixin from '~/mixins/query.mixin'
import ResponsiveMixin from '~/mixins/responsive.mixin'
import {ChefInterface} from "~/store/chef";

export default (Vue as VueConstructor<Vue & InstanceType<typeof ResponsiveMixin> & InstanceType<typeof QueryMixin>>).extend({
  name: 'Profile',
  mixins: [ResponsiveMixin, QueryMixin],
  head() {
    return {
      bodyAttrs: {
        class: 'bg-white text-offBlack'
      },
      title: this.$data.seoTitle,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$data.seoDescriptionMeta,
        }
      ],
    }
  },
  data(): {
    mobileMenuOpen: boolean,
    showChefScorePopup: boolean,
    seoTitle: string,
    seoDescriptionMeta: string,
    chef: ChefInterface | null,
    form: {
      name: string,
      email: string,
      message: string,
      rating: {
        coordination: number,
        recommendation: number,
        overall: number,
        quality: number,
        professionalism: number,
      },
    },
    loading: boolean,
  } {
    return {
      mobileMenuOpen: false,
      showChefScorePopup: false,
      seoTitle: '',
      seoDescriptionMeta: '',
      chef: null,
      form: {
        name: "",
        email: "",
        message: "",
        rating: {
          coordination: 0,
          recommendation: 0,
          overall: 0,
          quality: 0,
          professionalism: 0,
        },
      },
      loading: false,
    }
  },
  computed: {
    experienceId(): string {
      return this.$route.query.experience_id;
    },
    chefIdOrSlug(): string {
      return this.$route.params.id;
    },
    chefId(): string {
      return (this.chef?.id ?? 0).toString(10);
    },
  },
  methods: {
    submitReview: async function () {
      if (!this.chef) {
        return;
      }

      const formData = new FormData();
      const files = this.$refs.files.files;
      for (let i = 0; i < files.length; i++) {
        let file = files[i];
        formData.append('file[' + i + ']', file);
      }

      formData.append('name', this.form.name);
      formData.append('email', this.form.email);
      formData.append('message', this.form.message);
      formData.append('rating', JSON.stringify(this.form.rating));

      this.loading = true;

      // await this.$axios.$post(`/v1/chef/${this.chef.id}/review/${this.experienceId}`, formData, {
      await this.$axios.$post(`https://butler.chefstbl.com/api/marketplace/v1/chef/${this.chef.id}/review/${this.experienceId}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      });

      this.loading = false;

      // Reset
      this.form = {
        name: "",
        email: "",
        message: "",
        rating: {
          coordination: 0,
          recommendation: 0,
          overall: 0,
          quality: 0,
          professionalism: 0,
        }
      };

      alert('Bedankt voor je review. We controleren je review voor we deze op de website tonen. Binnen 24 uur is een goedgekeurde review zichtbaar.');
    }
  },
  async fetch() {
    // @ts-ignore
    this.chef = await this.$axios.$get<{ data: ChefInterface }>(`/v1/chef/${this.chefIdOrSlug}`).then(data => data.data).catch(() => {
      this.$nuxt.context.redirect('/');
      return;
    });

    if (!this.chef) {
      return;
    }

    this.seoTitle = `${this.chef.display_name} schrijf review`;
    this.seoDescriptionMeta = `Schrijf hier een review over ${this.chef.display_name}`;
  }
})
